import { useTranslations } from "next-intl";
const Footer = () => {
  const t = useTranslations();
  return <footer className="mt-8 text-center pb-8 bg-slate-100">
        <div className="flex justify-center gap-4 mb-3 text-sm text-gray-500">
          <a href="#" className="hover:underline">{t("Privacy Policy")}</a>
          <span>•</span>
          <a href="#" className="hover:underline">{t("Terms of Use")}</a>
          <span>•</span>
          <a href="#" className="hover:underline">{t("Contact Us")}</a>
        </div>
        <div className="text-sm text-gray-500">{t("Design and developed by 2025 Vidarbha Infotech Private Limited")}</div>
      </footer>;
};
export default Footer;